import { Button, Dropdown, Table, Space, Card, Row } from "antd";
import React, { useEffect } from "react";
import UploadData from "../Modals/UploadData";
import { fetchVersions } from "../../apis";
import "../../styles/admin/admin-dashboard.css";
import "../../styles/admin/admin-tables.css";

function DataClient() {
  var [isNewVersion, setIsNewVersion] = React.useState(false);
  var [data, setData] = React.useState([]);

  var fetchData = async () => {
    // Fetch data logic here
    setIsNewVersion(false);
    // Simulate fetching data
    var response = await fetchVersions()
    if (response.status !== 200) {
      console.error("Error fetching data:", response.statusText);
      setData([]);
    } else {
      setData(response.data);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  var columns = [
    {
      title: "Version Name",
      dataIndex: "version",
    },
    {
      title: "Created At",
      dataIndex: "created_at",
    },
  ];

  return (
    <Card
      bordered={false}
      className="admin-table-container"
    >

      <h1>Data Client Versions</h1>
      <p>Manage your data client versions here.</p>
      <Row justify={"end"} className="admin-table-actions">
        <Button
          type="primary"
          className="admin-form-button-primary"
          onClick={() => setIsNewVersion(true)}
        >
          Add New Version
        </Button>
      </Row>
      <UploadData
        visible={isNewVersion}
        onCancel={() => setIsNewVersion(false)}
        onSuccess={fetchData}
      />
      <Table columns={columns} dataSource={data} bordered className="admin-data-table" />
    </Card>
  );
}

export default () => {
  return <div className="admin-dashboard-container">
    <DataClient />
  </div>
};
